import Field from './Field';
import Title from './Title';

export default {
  Field,
  Title
};
